const Payment = class Payment {
    constructor() {
        this.number = '';
        this.exp_month = null;
        this.exp_year = null;
        this.cvc = '';
        this.isPrimary = true;
    }
};

export default Payment;
